// src/components/AddEditStaffModal/hooks/useStaffForm.js
import { useState, useEffect, useMemo } from 'react';
import { useFormik } from 'formik';
import { staffValidationSchema } from '../validationSchema';
import moment from 'moment';
import {
    createStaff,
    editStaff,
    getSingleStaff,
    getSalaryTypeList,
    getBaseRateTypeList,
    getLeadSourceList,
    getchZoneList,
    getHubList,
    getStaffTypeList,
    getRateCard,
    fetchClientList,
    getStaffCityZones,
    getHubListWithFilters,
} from '../../../../store/actions/staffActionCreator';
import { fetchVendorList } from '../../../../store/actions/staffActionCreator';
import { Button } from '@material-ui/core';
import { HUB_TYPE_ENUM } from '../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchShiftfilterList,
    GetBusinessList,
} from '../../../../store/actions/settingsActionCreator';
import { checkHttpStatus, showMessage } from '../../../../utils/helper';
import { fetchVehicleTypes } from '../../../../store/actions/attendanceActionCreator';
import Swal from 'sweetalert2';
import { shiftOverlapValidation } from '../../AssignStaffToHubModal';
import { isEqual } from 'lodash';

export function useStaffForm({ onClose, isEdit, data = {} }) {
    const dispatch = useDispatch();
    const operatingCityId = useSelector(
        (state) => state?.settings?.basicDetails?.operatingCityId,
    );
    const orgId = useSelector((state) => state?.settings?.basicDetails?.id);
    const hubs = useSelector((state) => state?.staff?.hubs);
    const leadSources = useSelector((state) => state?.staff?.leadSources);
    const orgCustomerMappings = useSelector(
        (state) => state?.settings?.orgCustomerMappings,
    );

    const initialValues = {
        name: '',
        contactNumber: '',
        dateOfBirthEpochMillis: null,
        joiningDateEpochMillis: null,
        staffTypeId: '',
        vehicleTypeId: '',
        vehicleNumber: '',
        selfieEnabled: true,
        trackAndTraceEnabled: true,
        geofenceAutoApproval: true,
        hubId: '',
        zones: [],
        shiftTimingIds: [],
        trainingCompleted: false,
        freelancer: false,
        salaryType: 4,
        salaryCycle: '',
        salaryCycleDay: '',
        baseRate: '',
        baseRateType: '',
        openingBalance: '',
        staffCustCode: '',
        vendorId: '',
        customerId: '',
        clients: [],
        userCreationSource: 'Self Onboarded',
        userCreationSourceId: '',
        sourceRemarks: '',
    };

    const formik = useFormik({
        initialValues,
        validationSchema: staffValidationSchema,
        onSubmit: async (state, { setFieldError, ...formikbag }) => {
            try {
                console.log('Formik formikbag:', formikbag);
                setLoading(true);
                let shiftTimingIds = [];
                let isFoodHubSelected = false;
                workTabHubNShiftList?.forEach((hub) => {
                    if (hub.primaryOperation === HUB_TYPE_ENUM.FOOD.value) {
                        isFoodHubSelected = true;
                    }
                    if (hub?.shifts?.length)
                        shiftTimingIds = [
                            ...shiftTimingIds,
                            ...hub?.shifts?.map((s) => s?.id),
                        ];
                });
                let zoneId = [];
                Object.keys(zonesWithHub).forEach((zone) => {
                    zoneId = [
                        ...zoneId,
                        ...(zonesWithHub[zone].map((z) => z?.id) ?? []),
                    ];
                });
                if (
                    !zonesWithHub?.FOOD?.length &&
                    !state?.zones?.length &&
                    isFoodHubSelected &&
                    !isEdit
                ) {
                    formik.setFieldError(
                        'zones',
                        'At least one zone must be selected',
                    );
                    setLoading(false);
                    return;
                } else {
                    formik.setFieldError('zones', null);
                    formik.setTouched({
                        zones: false,
                    });
                }
                let userCreationSourceId = leadSources?.staticValues
                    .filter((x) => x.name === state?.userCreationSource)
                    .map((x) => x.id)[0];
                let vendorId =
                    state.userCreationSource &&
                    state.userCreationSource === 'Vendor'
                        ? state?.vendorId
                        : null;
                const commonValues = {
                    name: state?.name,
                    contactNumber: state?.contactNumber,
                    vehicleTypeId: state?.vehicleTypeId,
                    vehicleNumber: !!state?.vehicleNumber
                        ? state?.vehicleNumber
                        : state?.contactNumber,
                    hubId: state?.hubId ?? null,
                    selfieEnabled: state?.selfieEnabled,
                    // geofenceEnabled: state?.geofenceEnabled,
                    trackAndTraceEnabled: state?.trackAndTraceEnabled,
                    geofenceAutoApproval: state?.geofenceAutoApproval,
                    // companyId: state?.companyId,
                    dateOfBirthEpochMillis: moment(
                        state?.dateOfBirthEpochMillis,
                    ).valueOf(),
                    staffType: state?.staffTypeId,
                    salaryType: state?.salaryType,
                    salaryCycle: state?.salaryCycle,
                    salaryCycleDay: state?.salaryCycleDay,
                    openingBalance: state?.openingBalance,
                    baseRate: state?.baseRate,
                    baseRateType: state?.baseRateType,
                    freelancer: state?.freelancer,
                    staffCreatedSoruce: 'CREATE_STAFF',
                    staffCustCode: state?.staffCustCode,
                    vendorId,
                    userCreationSourceId,
                    userCreationSource: state?.userCreationSource,
                    sourceRemarks: state?.sourceRemarks,
                    customerId: state?.customerId,
                    customers:
                        state?.clients?.filter(
                            (item) => !!item && item?.customerId,
                        ) ?? [],
                    shiftTimingIds,
                    isTrainingCompleted: trainingCompleted === 'true',
                    joiningDateEpochMillis:
                        state?.joiningDateEpochMillis === 0
                            ? moment().valueOf()
                            : moment(state?.joiningDateEpochMillis).valueOf(),
                    zoneId,
                };
                if (isEdit) {
                    let payload = {
                        id: state?.id,
                        value: commonValues,
                    };
                    dispatch(
                        editStaff(
                            payload,
                            async () => {
                                // console.log('Edit Staff SUCCESS');
                                await setLoading(false);
                                onClose();
                                showMessage(
                                    'Staff Edited Successfully',
                                    'success',
                                );
                            },
                            async () => {
                                await setLoading(false);
                                // console.log('Edit Staff FAILED');
                            },
                        ),
                    );
                } else {
                    let payload = {
                        ...commonValues,
                        dateOfBirthEpochMillis: moment(
                            state?.dateOfBirthEpochMillis,
                        ).valueOf(),
                        customers:
                            state?.clients?.filter(
                                (item) => !!item && item?.customerId,
                            ) ?? [],
                        staffCreatedSoruce: 'CREATE_STAFF',
                    };
                    dispatch(
                        createStaff(
                            payload,
                            async () => {
                                // console.log('Add Staff SUCCESS');
                                await setLoading(false);
                                onClose();
                                showMessage(
                                    'Staff Created Successfully',
                                    'success',
                                );
                            },
                            async () => {
                                await setLoading(false);
                                // console.log('Add Staff FAILED');
                            },
                        ),
                    );
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                setLoading(false);
            }
        },
    });

    const [loading, setLoading] = useState(false);

    const [activeTab, setActiveTab] = useState(0);
    const [salaryTypeList, setSalaryTypeList] = useState([]);
    const [salaryCycleList] = useState([
        { id: 1, name: 'Weekly', value: 'Weekly' },
        {
            id: 2,
            name: 'Bi-Weekly',
            value: 'Bi-Weekly',
        },
        {
            id: 3,
            name: 'Monthly',
            value: 'Monthly',
        },
    ]);
    const [salaryCycleDayList, setSalaryCycleDayList] = useState([]);
    const [rateCardResponse, setRateCardResponse] = useState({});
    const [baseRateTypesList, setBaseRateTypesList] = useState([]);
    const [filteredBaseRateTypesList, setFilteredBaseRateTypesList] = useState(
        [],
    );

    const [vehicleTypesList, setVehicleTypesList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [weekList, setWeekList] = useState([]);
    const [weekDaysList, setWeekDaysList] = useState([]);

    const [workTabHubNShiftList, setWorkTabHubNShiftList] = useState([{}]);

    const [shiftsWithHub, setShiftsWithHub] = useState({});
    const [zonesWithHub, setZonesWithHub] = useState({
        [HUB_TYPE_ENUM.FOOD.value]: [],
        [HUB_TYPE_ENUM.ECOM.value]: [],
        [HUB_TYPE_ENUM.STORE.value]: [],
    });

    const [rateCardPayload, setRateCardPayload] = useState({
        userId: isEdit ? data?.id : null,
        hubId: formik.values?.hubId ?? null,
        staffCustCode: isEdit ? data?.staffCustCode : null,
    });

    const [overlapShifts, setOverlapShift] = useState([]);
    const [bothShiftsIsThere, setBothShiftsIsThere] = useState(false);
    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true);
    const [allowHubZoneEdit, setAllowHubZoneEdit] = useState(!isEdit);
    const [trainingCompleted, setTrainingCompleted] = useState(
        data?.trainingCompleted != null
            ? data?.trainingCompleted.toString()
            : 'false',
    );

    // {hubId1 : [], hubId2 : []}
    const [zoneOptions, setZoneOptions] = useState({});

    const modalTitle = isEdit ? 'Edit Staff' : 'Add New Staff';

    const fetchVendor = () => {
        dispatch(
            fetchVendorList(
                (resp) => {
                    setVendorList(resp?.response?.vendors);
                },
                (err) => {},
            ),
        );
    };
    const getLeadSourcesList = () => {
        dispatch(
            getLeadSourceList(
                'LEAD_SOURCE',
                (resp) => {
                    !isEdit && setLoading(false);
                },
                (resp) => {
                    !isEdit && setLoading(false);
                },
            ),
        );
    };

    const checkRosterShiftsForConflicts = (shifts = []) => {
        let hasRosterShift = false;
        let hasNormalShift = false;
        let conflictShifts = [];
        let conflictShiftIds = new Set();

        for (let i = 0; i < shifts?.length; i++) {
            const shiftA = shifts?.[i];

            if (shiftA?.rosterShift) {
                hasRosterShift = true;
            } else {
                hasNormalShift = true;
            }

            for (let j = i + 1; j < shifts?.length; j++) {
                const shiftB = shifts?.[j];

                // **Check if Roster and Normal Shift are mixed**
                if (hasRosterShift && hasNormalShift) {
                    return {
                        conflict: true,
                        message: 'Cannot mix Roster and Normal shifts.',
                        conflictShifts: [],
                    };
                }

                // **Check for overlapping shifts on same roster days**
                if (shiftA?.rosterShift && shiftB?.rosterShift) {
                    const rosterDaysA = shiftA?.rosterDays
                        ? shiftA?.rosterDays.split(',').map(Number)
                        : [];
                    const rosterDaysB = shiftB?.rosterDays
                        ? shiftB?.rosterDays.split(',').map(Number)
                        : [];

                    const commonDays = rosterDaysA?.filter((day) =>
                        rosterDaysB?.includes(day),
                    );

                    if (commonDays?.length > 0) {
                        if (
                            (shiftA?.startTimeEpochMillis <
                                shiftB?.endTimeEpochMillis &&
                                shiftA?.endTimeEpochMillis >
                                    shiftB?.startTimeEpochMillis) ||
                            (shiftB?.startTimeEpochMillis <
                                shiftA?.endTimeEpochMillis &&
                                shiftB?.endTimeEpochMillis >
                                    shiftA?.startTimeEpochMillis)
                        ) {
                            conflictShifts?.push({
                                shiftA,
                                shiftB,
                                commonDays,
                            });
                            if (!!shiftA?.id) conflictShiftIds?.add(shiftA.id);
                            if (!!shiftB?.id) conflictShiftIds?.add(shiftB.id);
                        }
                    }
                }
            }
        }

        if (conflictShifts?.length > 0) {
            return {
                conflict: true,
                message: 'Overlapping shifts detected.',
                conflictShiftIds: Array.from(conflictShiftIds), // Convert Set to Array
                conflictShifts,
            };
        }

        return {
            conflict: false,
            message: 'No conflicts found.',
            conflictShiftIds: [],
            conflictShifts: [],
        };
    };

    function checkoverlapping() {
        let shiftIds = [];
        let isShiftOverlapping = false;

        workTabHubNShiftList.forEach((hub) => {
            shiftIds = [
                ...shiftIds,
                ...(hub?.shifts?.length ? hub?.shifts : []),
            ];
        });
        const hasRosterSelected = shiftIds.some((s) => s.rosterShift);
        const hasNormalSelected = shiftIds.some((s) => !s.rosterShift);
        if (!!hasNormalSelected && !!hasRosterSelected) {
            Swal.fire({
                icon: 'error',
                title: 'HUBS & Shifts',
                text: 'Cannot mix roster and normal shifts in the list. please check',
            });
            setBothShiftsIsThere(true);
            isShiftOverlapping = true;
            // setSubmitButtonDisabled(true);
            return isShiftOverlapping;
        } else {
            setBothShiftsIsThere(false);
        }
        if (!!hasRosterSelected) {
            const result = checkRosterShiftsForConflicts(shiftIds);
            console.log(
                'checkoverlapping roster check',
                JSON.stringify(result, null, 2),
            );
            if (result?.conflict) {
                Swal.fire({
                    icon: 'error',
                    title: 'HUBS & Shifts',
                    text:
                        result?.message ??
                        'Shift timing overlap is there please check',
                });
            }

            setOverlapShift(result?.conflictShiftIds ?? []);
            isShiftOverlapping = result?.conflict ?? false;
            // setSubmitButtonDisabled(result?.conflict ?? false);

            return isShiftOverlapping;
        } else {
            const { overlapList, overlapping } =
                shiftOverlapValidation(shiftIds);
            setOverlapShift(overlapList);
            if (overlapping) {
                Swal.fire({
                    icon: 'error',
                    title: 'HUBS & Shifts',
                    text: 'Shift timing overlap is there please check',
                });
            }
            isShiftOverlapping = overlapping;
            // setSubmitButtonDisabled(overlapping);
            return isShiftOverlapping;
        }

        // isSubmitButtonDisabled = overlapping;
        // setSubmitDisabled(overlapping);
    }

    useEffect(() => {
        const weekList = [];
        moment?.weekdays()?.forEach((day, index) => {
            weekList?.push({
                id: index,
                name: day,
                value: day,
            });
        });
        let weekDays = [];
        let days = Array.from({ length: 28 }, (_, i) => i + 1);
        // console.log('Days', days);
        days?.forEach((day, index) => {
            weekDays?.push({
                id: index,
                name: day,
                value: day,
            });
        });
        setWeekList(weekList);
        setWeekDaysList(weekDays);
        setLoading(true);
        // dispatch(
        //     getHubList(
        //         orgId,
        //         (resp) => {
        //             !isEdit && setLoading(false);
        //         },
        //         (resp) => {
        //             !isEdit && setLoading(false);
        //         },
        //     ),
        // );

        dispatch(
            getSalaryTypeList(
                (resp) => {
                    !isEdit && setLoading(false);
                    if (checkHttpStatus(resp.status)) {
                        setSalaryTypeList(resp?.response?.types);
                    }
                },
                (resp) => {
                    !isEdit && setLoading(false);
                },
            ),
        );
        dispatch(
            getStaffTypeList(
                (resp) => {
                    !isEdit && setLoading(false);
                },
                (resp) => {
                    !isEdit && setLoading(false);
                },
            ),
        );
        dispatch(
            getBaseRateTypeList(
                (resp) => {
                    !isEdit && setLoading(false);
                    if (checkHttpStatus(resp.status)) {
                        // console.log('ZZZZZZZ', resp);
                        setBaseRateTypesList(resp?.response?.types);
                        switch (formik.values?.salaryType) {
                            case 1:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter((baseRate) =>
                                        baseRate?.name
                                            ?.toLowerCase()
                                            ?.includes('month'),
                                    ),
                                );
                                break;
                            case 2:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter((baseRate) =>
                                        baseRate?.name
                                            ?.toLowerCase()
                                            ?.includes('day'),
                                    ),
                                );
                                break;
                            case 3:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter((baseRate) =>
                                        baseRate?.name
                                            ?.toLowerCase()
                                            ?.includes('hour'),
                                    ),
                                );
                                break;
                            case 4:
                                setFilteredBaseRateTypesList(
                                    resp?.response?.types?.filter(
                                        (baseRate) =>
                                            !(
                                                baseRate?.name
                                                    ?.toLowerCase()
                                                    ?.includes('month') ||
                                                baseRate?.name
                                                    ?.toLowerCase()
                                                    ?.includes('day') ||
                                                baseRate?.name
                                                    ?.toLowerCase()
                                                    ?.includes('hour')
                                            ),
                                    ),
                                );
                                break;
                            default:
                                setFilteredBaseRateTypesList(baseRateTypesList);
                                break;
                        }
                    }
                },
                () => {},
            ),
        );
        dispatch(
            getRateCard(
                rateCardPayload,
                (resp) => {
                    // console.log('RateCardResponse', resp);
                    setLoading(false);
                    setRateCardResponse(resp?.response);
                },
                () => {
                    setLoading(false);
                },
            ),
        );
        dispatch(
            fetchClientList(
                (resp) => {
                    setClientList(resp?.response?.customers);
                },
                (err) => {},
            ),
        );
        dispatch(
            fetchVehicleTypes(
                (resp) => {
                    // console.log('Vehicle Types', resp?.response);
                    setVehicleTypesList(resp?.response?.vehicleTypes);
                },
                (err) => {
                    // console.log('Vehicle Types Error', err);
                    setVehicleTypesList([]);
                },
            ),
        );
        fetchVendor();
        getLeadSourcesList();

        if (isEdit) {
            // console.log('data', data);
            // setState(data);
            setLoading(true);
            dispatch(
                getSingleStaff(
                    data?.id,
                    (resp) => {
                        if (checkHttpStatus(resp?.status)) {
                            formik.setValues({
                                ...resp?.response,
                                clients: resp?.response?.customers ?? [],
                                joiningDateEpochMillis:
                                    resp?.response?.joiningDateEpochMillis > 0
                                        ? resp?.response?.joiningDateEpochMillis
                                        : moment().valueOf(),

                                dateOfBirthEpochMillis:
                                    resp?.response?.dateOfBirthEpochMillis > 0
                                        ? resp?.response?.dateOfBirthEpochMillis
                                        : null,
                                salaryType:
                                    resp?.response?.salaryTypeId > 0
                                        ? resp?.response?.salaryTypeId
                                        : '',
                            });
                            let hubShiftMapping =
                                resp?.response?.hubShiftMappings;
                            const newZoneInfo = {
                                ...zonesWithHub,
                            };
                            let operationData = [];
                            if (!!hubShiftMapping?.length) {
                                setWorkTabHubNShiftList([
                                    ...hubShiftMapping?.map((hub) => {
                                        return {
                                            hubId: hub.hubId,
                                            hubInfo: hub,
                                            business: hub?.orgCustomerId,
                                            custInfo: {
                                                id: hub?.orgCustomerId,
                                                aliasName: hub?.customerName,
                                            },
                                            primaryOperation:
                                                hub?.primaryOperation,
                                        };
                                    }),
                                    {},
                                ]);
                                hubShiftMapping?.forEach((hub, idx) => {
                                    const shiftIds = hub?.shiftLineItems;
                                    getShiftfromHubId(
                                        hub?.hubId,
                                        idx,
                                        shiftIds,
                                    );
                                });

                                operationData = resp?.response?.omsUserDetails;
                            }
                            if (!!operatingCityId)
                                dispatch(
                                    getStaffCityZones(
                                        operatingCityId ?? 1,
                                        (resp) => {
                                            !isEdit && setLoading(false);
                                            operationData?.forEach((op) => {
                                                newZoneInfo[
                                                    op?.primaryOperation
                                                ] = !!op?.zones?.length
                                                    ? resp?.response?.zones?.filter(
                                                          (z) => {
                                                              return op?.zones?.includes(
                                                                  z?.id,
                                                              );
                                                          },
                                                      )
                                                    : [];
                                            });
                                            setZonesWithHub({ ...newZoneInfo });
                                        },
                                        (resp) => {
                                            !isEdit && setLoading(false);
                                        },
                                    ),
                                );

                            // console.log('getSingleSTaff SUCCESS');
                            setLoading(false);
                        }
                    },
                    () => {
                        // console.log('getSingleSTaff FAILED');
                        setLoading(false);
                    },
                ),
            );
        }
    }, []);

    useEffect(() => {
        setWorkTabHubNShiftList((prev) => {
            const allshiftIds = [];
            const newList = prev?.map((hub) => {
                let newRecord = {
                    ...hub,
                };
                if (!!shiftsWithHub?.[hub?.hubId]) {
                    newRecord = {
                        ...newRecord,
                        ...shiftsWithHub?.[hub?.hubId],
                    };
                }
                if (!!newRecord?.shifts?.length) {
                    allshiftIds?.push(...newRecord?.shifts?.map((s) => s?.id));
                }
                return newRecord;
            });
            setZonesWithHub((prev) => prev);
            formik.setFieldValue('shiftTimingIds', allshiftIds, true);
            return newList;
        });
    }, [shiftsWithHub]);
    useEffect(() => {
        if (zonesWithHub.FOOD?.length > 0) {
            formik.setFieldValue('zones', zonesWithHub.FOOD, true);
            formik.setTouched({
                zones: false,
            });
        } else {
            if (!isEdit) {
                formik.setFieldValue('zones', zonesWithHub.FOOD, true);
                formik.setTouched({
                    zones: true,
                });
                formik.setErrors({
                    zones: 'Please select zone',
                });
                formik.setFieldError('zones', 'Please select zone', true);
            }
        }
    }, [zonesWithHub]);

    useEffect(() => {
        setRateCardPayload((prev) => {
            return {
                ...prev,
                hubId: formik?.values?.hubId,
            };
        });
    }, [formik?.values?.hubId]);

    useEffect(() => {
        // setState((prev) => {
        //     return {
        //         ...prev,
        //         salaryCycleDay: '',
        //     };
        // });
        if (
            formik?.values?.salaryCycle === 'Weekly' ||
            formik?.values?.salaryCycle === 'Bi-Weekly'
        ) {
            setSalaryCycleDayList(weekList);
        } else if (formik?.values?.salaryCycle === 'Monthly') {
            setSalaryCycleDayList(weekDaysList);
        }
    }, [formik?.values?.salaryCycle, weekDaysList, weekList]);

    useEffect(() => {
        // console.log('workTabHubNShiftList', workTabHubNShiftList);
        let isShiftOverlapping = checkoverlapping();
        isShiftOverlapping = !workTabHubNShiftList?.filter(
            (hub) => !!hub?.shifts?.length,
        )?.length;
    }, [workTabHubNShiftList]);

    const getShiftfromHubId = async (
        hubId,
        workTabHubNShiftListIndex,
        shifts = null,
    ) => {
        await dispatch(
            fetchShiftfilterList(
                {
                    hubIds: [hubId],
                },
                async (resp) => {
                    const shiftList = shifts?.map((shift) => {
                        return resp?.response?.shifts?.find(
                            (i) => i?.id === shift?.id,
                        );
                    });
                    setShiftsWithHub((prev) => ({
                        ...prev,
                        [hubId]: {
                            index: workTabHubNShiftListIndex,
                            shifts: shiftList,
                            shiftList: resp?.response?.shifts?.filter(
                                (shift) => !shift?.slotShift,
                            ),
                        },
                    }));
                },
                (err) => {
                    // console.log('err', err);
                },
            ),
        );
    };

    const getZonesFromHubId = async (hubId) => {
        let payload = { cityId: operatingCityId, hubIds: [hubId] };

        await dispatch(
            getchZoneList(
                payload,
                (resp) => {
                    if (resp?.response?.zones?.length)
                        setZoneOptions((prev) => {
                            return {
                                ...prev,
                                [hubId]: resp?.response?.zones,
                            };
                        });
                },
                (err) => {},
            ),
        );
    };

    const fetchHubListWithFilters = (filters, onSucess, onFailure) => {
        dispatch(getHubListWithFilters(orgId, filters, onSucess, onFailure));
    };
    const fetchBusinessList = (filters, onSucess, onFailure) => {
        dispatch(GetBusinessList(orgId, filters, onSucess, onFailure));
    };

    const handlers = useMemo(
        () => ({
            onChange: (key, value) => {
                formik.setFieldValue(key, value);
            },
            addClient: () => {
                formik.setFieldValue('clients', [
                    ...formik.values?.clients,
                    { customerId: '', staffCustCode: '' },
                ]);
            },
            removeClient: (index) => {
                formik.setFieldValue(
                    'clients',
                    formik.values?.clients?.filter((_, i) => i !== index),
                );
            },
            updateClient: (index, key, value) => {
                formik.setFieldValue(
                    'clients',
                    formik.values?.clients?.map((c, i) =>
                        i === index ? { ...c, [key]: value } : c,
                    ),
                );
            },
        }),
        [formik],
    );

    const actions = useMemo(() => {
        const isFormFieldIsSameAsInitialValues = isEqual(
            formik.values,
            formik.initialValues,
        );
        return [
            <Button
                key={1}
                variant="contained"
                color="default"
                className={`cancelButton`}
                disableElevation
                onClick={onClose}
            >
                Cancel
            </Button>,
            <Button
                key={2}
                variant="contained"
                color="primary"
                className={`saveButton`}
                disableElevation
                onClick={formik.handleSubmit}
                disabled={
                    loading ||
                    formik.isSubmitting ||
                    isFormFieldIsSameAsInitialValues
                }
            >
                {isEdit ? 'Edit Staff' : 'Add Staff'}
            </Button>,
        ];
    }, [
        formik.handleSubmit,
        formik.initialValues,
        formik.isSubmitting,
        formik.isValid,
        formik.values,
        isEdit,
        loading,
        onClose,
    ]);

    console.log('stateProps formik', formik.errors);

    const formProps = {
        formik,
        handlers,
        vendorList,
        clientList,
    };

    const stateProps = {
        // useState
        overlapShifts,
        setOverlapShift,
        bothShiftsIsThere,
        setBothShiftsIsThere,
        isSubmitButtonDisabled,
        setSubmitButtonDisabled,
        allowHubZoneEdit,
        setAllowHubZoneEdit,
        shiftsWithHub,
        setShiftsWithHub,
        zoneOptions,
        setZoneOptions,
        zonesWithHub,
        setZonesWithHub,
        workTabHubNShiftList,
        setWorkTabHubNShiftList,
        vehicleTypesList,
        orgCustomerMappings,
        // salary tab
        salaryTypeList,
        salaryCycleList,
        salaryCycleDayList,
        rateCardResponse,
        filteredBaseRateTypesList,
    };

    return {
        formik,
        activeTab,
        handleTabChange: (_, v) => setActiveTab(v),
        actions,
        loading,
        modalTitle,
        formProps,
        stateProps,
        // functions
        getShiftfromHubId,
        getZonesFromHubId,
        fetchHubListWithFilters,
        fetchBusinessList,
    };
}
